export class Loader {
    constructor() {
        this._count = 0;
    }
    get active() {
        return this._count > 0;
    }
    get count() {
        return this._count;
    }
    begin() {
        this._count++;
        return this;
    }
    end() {
        if (this._count > 0)
            this._count--;
        return this;
    }
    reset() {
        this._count = 0;
        return this;
    }
    async task(task) {
        this.begin();
        try {
            return await task();
        }
        finally {
            this.end();
        }
    }
}
//# sourceMappingURL=index.js.map